import React, { useContext } from "react";
import Logo from "../Logo";
import { ModelContext } from "../../contexts/ModelContextProvider";
import RegisterForm from "../forms/RegisterForm";
import styles from "./RegisterCard.module.css";

const RegisterCard = () => {
  const { setClose } = useContext(ModelContext);
  return (
    <section className={`d-md-flex ${styles.container}`}>
      <div className={`col-md-6 ${styles.leftContainer} p-5 p-md-6 d-flex flex-column justify-content-between`}>
        <div className="pt-5">
          <Logo
            style={{ width: "70px", height: "70px", borderRadius: "20px" }}
          />
          <h3 className="pt-4 mh-80">
            Revolutionizing Research Publishing & Management
          </h3>
        </div>
        <p>
          Already have an account?{" "}
          <span onClick={setClose} style={{ cursor: "pointer",color:"var(--gray)" }}>Login here.</span>
        </p>
      </div>

      <div
        className={`col-md-6 p-0 p-md-5 p-md-6 d-flex align-items-center ${styles.rightContainer}`}
      >
        <RegisterForm />
      </div>
    </section>
  );
};

export default RegisterCard;
